export const SupplyRecipe = {
    $type$: 'Recipe',
    name: 'Supply',
    rule: [
        {
            itemprop: 'identity',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'match',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'isActive',
            itemtype: { type: 'boolean' }
        },
        {
            itemprop: 'timestamp',
            itemtype: { type: 'number' }
        }
    ]
};
export const DemandRecipe = {
    $type$: 'Recipe',
    name: 'Demand',
    rule: [
        {
            itemprop: 'identity',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'match',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'isActive',
            itemtype: { type: 'boolean' }
        },
        {
            itemprop: 'timestamp',
            itemtype: { type: 'number' }
        }
    ]
};
export const SupplyMapRecipe = {
    $type$: 'Recipe',
    name: 'SupplyMap',
    rule: [
        {
            itemprop: 'name',
            itemtype: { type: 'string' },
            isId: true
        },
        {
            itemprop: 'map',
            itemtype: { type: 'map', key: { type: 'string' }, value: { type: 'stringifiable' } }
        }
    ]
};
export const DemandMapRecipe = {
    $type$: 'Recipe',
    name: 'DemandMap',
    rule: [
        {
            itemprop: 'name',
            itemtype: { type: 'string' },
            isId: true
        },
        {
            itemprop: 'map',
            itemtype: { type: 'map', key: { type: 'string' }, value: { type: 'stringifiable' } }
        }
    ]
};
export const MatchingResponseRecipe = {
    $type$: 'Recipe',
    name: 'MatchResponse',
    rule: [
        {
            itemprop: 'identity',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'match',
            itemtype: { type: 'string' }
        },
        {
            // will be true if the above identity belongs to
            // the person who has send the Demand object
            itemprop: 'identityOfDemand',
            itemtype: { type: 'boolean' }
        },
        {
            itemprop: 'creationTimestamp',
            itemtype: { type: 'number' }
        }
    ]
};
export const MatchMapRecipe = {
    $type$: 'Recipe',
    name: 'MatchMap',
    rule: [
        {
            itemprop: 'name',
            itemtype: { type: 'string' },
            isId: true
        },
        {
            itemprop: 'array',
            itemtype: {
                type: 'bag',
                item: { type: 'referenceToObj', allowedTypes: new Set(['MatchResponse']) }
            }
        }
    ]
};
export const NotifiedUsersRecipe = {
    $type$: 'Recipe',
    name: 'NotifiedUsers',
    rule: [
        {
            itemprop: 'name',
            itemtype: { type: 'string' },
            isId: true
        },
        {
            // map with destination person id hash as key and set
            // with hashes of sent MatchResponse objects as value
            itemprop: 'existingMatches',
            itemtype: { type: 'map', key: { type: 'string' }, value: { type: 'stringifiable' } },
            optional: true
        }
    ]
};
const MatchingRecipes = [
    SupplyRecipe,
    DemandRecipe,
    SupplyMapRecipe,
    DemandMapRecipe,
    MatchingResponseRecipe,
    MatchMapRecipe,
    NotifiedUsersRecipe
];
export default MatchingRecipes;
//# sourceMappingURL=MatchingRecipes.js.map